<template>
  <nav :aria-label="i18n.pagination.aria.navLabel">
    <div v-if="hotels.length > pagination.items_per_page" class="list-pagination">
      <div class="list-pagination__info" v-html="paginationText"></div>
      <div class="list-pagination__navigation">
        <button
          class="list-pagination__arrow s s-arrow-left-fat"
          :disabled="pagination.current_page === 1"
          :aria-label="i18n.pagination.aria.prevPage"
          @click="hotelsInfoStore.prevPage"
        >
          <span class="sr-only">{{ i18n.pagination.aria.prevPage }}</span>
        </button>
        <div class="list-pagination__pages">
          <button
            v-for="index in pagination.total_pages"
            :key="index"
            class="list-pagination__page"
            :class="{
              'list-pagination__page--active': index === pagination.current_page,
            }"
            data-test="list-pagination__page"
            :aria-label="`${i18n.pagination.aria.goToPage} ${index}`"
            :aria-current="index === pagination.current_page ? 'page' : undefined"
            @click="hotelsInfoStore.setPage(index)"
          >
            {{ index }}
          </button>
        </div>
        <button
          class="list-pagination__arrow s s-arrow-right-fat"
          :disabled="pagination.current_page === pagination.total_pages"
          :aria-label="i18n.pagination.aria.nextPage"
          @click="hotelsInfoStore.nextPage"
        >
          <span class="sr-only">{{ i18n.pagination.aria.nextPage }}</span>
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'

import { replaceTranslationKeys as t } from '../../../../../utils/replaceTranslationKeys'
import { useHotelsInfoStore } from '../../../blocks/HotelsInfo/store/hotels_info'

/**
 * Inject
 */
const i18n = inject('i18n')
const resourceTitle = inject('resourceTitle')

/**
 * Store
 */
const hotelsInfoStore = useHotelsInfoStore()
const { pagination, hotelsFiltered: hotels } = storeToRefs(hotelsInfoStore)

/**
 * Computed
 */
const paginationText = computed(() => {
  const startIndex = (pagination.value.current_page - 1) * pagination.value.items_per_page + 1
  const endIndex = Math.min(startIndex + pagination.value.items_per_page - 1, hotels.value.length)
  return t(i18n.value.pagination.text, {
    start_index: startIndex,
    end_index: endIndex,
    total_hotels: hotels.value.length,
    resource: resourceTitle,
  })
})
</script>

<!-- Styles -->
<style lang="scss">
@import 'shared/list_pagination/list_pagination_commons';
</style>
